export const HomeIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 6.18016V3.1535C14.6667 2.2135 14.24 1.8335 13.18 1.8335H10.4867C9.42667 1.8335 9 2.2135 9 3.1535V6.1735C9 7.12016 9.42667 7.4935 10.4867 7.4935H13.18C14.24 7.50016 14.6667 7.12016 14.6667 6.18016Z"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 13.68V10.9867C14.6667 9.92667 14.24 9.5 13.18 9.5H10.4867C9.42667 9.5 9 9.92667 9 10.9867V13.68C9 14.74 9.42667 15.1667 10.4867 15.1667H13.18C14.24 15.1667 14.6667 14.74 14.6667 13.68Z"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99967 6.18016V3.1535C6.99967 2.2135 6.57301 1.8335 5.51301 1.8335H2.81967C1.75967 1.8335 1.33301 2.2135 1.33301 3.1535V6.1735C1.33301 7.12016 1.75967 7.4935 2.81967 7.4935H5.51301C6.57301 7.50016 6.99967 7.12016 6.99967 6.18016Z"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99967 13.68V10.9867C6.99967 9.92667 6.57301 9.5 5.51301 9.5H2.81967C1.75967 9.5 1.33301 9.92667 1.33301 10.9867V13.68C1.33301 14.74 1.75967 15.1667 2.81967 15.1667H5.51301C6.57301 15.1667 6.99967 14.74 6.99967 13.68Z"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
